export enum EControllerType {
  Unknown = 'Unknown',
  MIXIT = 'MIXIT',
  CU352 = 'CU352',
  MOXA = 'MOXA'
}
